import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** 클래스 이름 결합기. clsx로 평탄화하고 tailwind-merge로 충돌 클래스를 정리한다. */
export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}

/** ISO 문자열을 로컬 날짜·시각으로 표시한다. 값이 없으면 '-'. */
export function formatDateTime(value: string | null | undefined): string {
    if (!value) return '-'
    const date = new Date(value)
    if (Number.isNaN(date.getTime())) return value
    return date.toLocaleString('ko-KR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
    })
}

/** "누가" 표시: 이름 > 이메일 > '—'. uuid 폴백 금지(uuid 노출 회피). */
export function whoLabel(name?: string | null, email?: string | null): string {
    return name || email || '—'
}

/** 세션 사용자 표시명: 이름 > 이메일 > 잘린 id > 익명. 잘린 UUID 노출을 줄인다. */
export function sessionUserLabel(session: {
    userName?: string | null
    userEmail?: string | null
    userId?: string | null
}): string {
    if (session.userName) return session.userName
    if (session.userEmail) return session.userEmail
    if (session.userId) return session.userId.slice(0, 8)
    return '익명'
}

/** 초 단위 소요시간을 사람이 읽는 표기(예: 3분 12초)로 변환한다. */
export function formatDuration(seconds: number | null | undefined): string {
    if (seconds == null || Number.isNaN(seconds)) return '-'
    const total = Math.max(0, Math.round(seconds))
    const h = Math.floor(total / 3600)
    const m = Math.floor((total % 3600) / 60)
    const s = total % 60
    if (h > 0) return `${h}시간 ${m}분`
    if (m > 0) return `${m}분 ${s}초`
    return `${s}초`
}
